import React, { useState } from "react";
import EnterpriseDealer_image from "../../assets/image/png/man-suit-with-briefcase-walks-past-cityscape-with-drone-him.jpg";
import EnlishNewDrone from "./EnlishNewDrone";

const EnlishNewDroneHero = () => {
  // States for each hover section
  const [isHoveredProgram, setIsHoveredProgram] = useState(false);
  const [isHoveredAbout, setIsHoveredAbout] = useState(false);
  const [isHoveredFeatures, setIsHoveredFeatures] = useState(false);

  return (
    <div className="py-4 bg-white">
      <div
        className="pt-5 bg_darkskyblue position-relative"
        style={{
          backgroundImage: `url(${EnterpriseDealer_image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Overlay */}
        <div className="overlay"></div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h3 className="hero-heading fs_34 ff_raleway fw-bold text-white">
                Become a Drone Planet Enterprise Dealer
              </h3>
              <p className="fs_24 ff_helvetica fw_400 text-white mt-4">
                Join the largest UAS network and expand your business offer with
                <br className="d-lg-block d-none"></br>
                valuable drone-based solutions.
              </p>

              {/* Join Our Drone Entrepreneurship Program */}
              <div className="hover-container" style={{ marginBottom: '10px' }}>
                <h5
                  className="fs_28 ff_raleway fw-bold text-white mb-2"
                  onMouseEnter={() => setIsHoveredProgram(true)}
                  onMouseLeave={() => setIsHoveredProgram(false)}
                >
                  Join Our Drone Entrepreneurship Program
                </h5>
                {isHoveredProgram && (
                  <div className="hover-card">
                    <p className="fs_16 ff_helvetica fw-normal text-white mb-4">
                      Join our program to learn drone piloting, start your business, and thrive in a high-demand industry.
                      Begin your exciting journey in the drone industry with our expert-led program. Gain the skills,
                      knowledge, and support to turn your passion into a profitable business.
                    </p>
                  </div>
                )}
              </div>

              {/* About the Program */}
              <div className="hover-container" style={{ marginBottom: '10px' }}>
                <h5
                  className="fs_28 ff_raleway fw-bold text-white mb-2"
                  onMouseEnter={() => setIsHoveredAbout(true)}
                  onMouseLeave={() => setIsHoveredAbout(false)}
                >
                  About the Program
                </h5>
                {isHoveredAbout && (
                  <div className="hover-card">
                    <p className="fs_16 ff_helvetica fw-normal text-white mb-4">
                      Transform your future with our comprehensive drone entrepreneurship program. Learn, earn, and grow in the booming drone industry.
                    </p>
                  </div>
                )}
              </div>

              {/* Key Features */}
              <div className="hover-container" style={{ marginBottom: '10px' }}>
                <h5
                  className="fs_28 ff_raleway fw-bold text-white mb-2"
                  onMouseEnter={() => setIsHoveredFeatures(true)}
                  onMouseLeave={() => setIsHoveredFeatures(false)}
                >
                  Key Features
                </h5>
                {isHoveredFeatures && (
                  <div className="hover-card">
                    <p className="fs_16 ff_helvetica fw-normal text-white mb-4">
                      Explore the key benefits of our program, including expert mentorship, business setup, and practical drone training.
                    </p>
                  </div>
                )}
              </div>

              <ul className="list-unstyled mt-2">
                <li className="color_darkgray_3 mb-2">
                  <p className="fs_24 ff_helvetica fw_400 text-white mb-0">
                    Drone Pilot Training: Master drone flying with hands-on training.
                  </p>
                </li>
                <li className="color_darkgray_3 mb-2">
                  <p className="fs_24 ff_helvetica fw_400 text-white mb-0">
                    Business Setup: Launch and grow your own drone services.
                  </p>
                </li>
                <li className="color_darkgray_3 mb-2">
                  <p className="fs_24 ff_helvetica fw_400 text-white mb-0">
                    Expert Support: Get continuous mentorship and network with industry leaders.
                  </p>
                </li>
              </ul>
              <EnlishNewDrone />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnlishNewDroneHero;
